import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { CalendarDayData } from '../../models';
import { CalendarEventsComponent } from '../calendar-events';


/**
 * Component for custom day in dashboard calendar.
 */
@Component({
	selector: 'app-calendar-day',
	templateUrl: './calendar-day.component.html',
	imports: [
		CalendarEventsComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class CalendarDayComponent {

	@Input() focused: boolean = false;
	@Input() date: NgbDate | null = null;
	@Input() currentMonth: number | null = null;
	@Input() data: CalendarDayData | null | undefined;

}
